<template>
  <div class="answer" v-if="showDialog">
    <mobile-header
      ref="mobileHeader"
      :alwaysShow="true"
      customBackgroundColor="#FFFFFF"
      :goBack="goQaIndex"
      borderBottom="none"
      :rightTxt="true"
      :rightFun="rightFun"
    >
      <template slot="navTitle">
        <div class="nav-title">回复问题</div>
      </template>
      <div slot="optBtnRight">
        <div class="nav-right-text" :class="{ active: !rightTextActive }"></div>
      </div>
    </mobile-header>
    <div class="post-question-content">
      <div class="question">
        <van-field
          class="question-field question-content"
          :class="{ active: formData.content }"
          v-model="formData.content"
          type="textarea"
          :border="false"
          @input="changeContent"
          @focus="showPlaceholder = false"
          @blur="showPlaceholder = true"
        />
      </div>
      <div class="placeholder" v-show="showPlaceholder && !formData.content">
        <p class="placeholder-title">请输入回答…</p>
        <p class="textear-div">
          · 每次真诚的回应，都是爱与勇气的传递。<br />
          · 精华回答，会获得打赏和推荐；<br />
          · 建议您多换行和分段，排版更好看；<br />
          · 凝练小标题，更易阅读和理解。
        </p>
      </div>
      <div class="tip">
        <div class="tip-box add-tip" @click="show = true">
          <img
            class="icon-add"
            src="../../../images/qa/questions/icon-wenti.png"
            alt=""
          />
          <span class="tips">问题详情</span>
          <img
            class="icon-right"
            src="../../../images/qa/questions/icon-right2.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 智能验证弹窗 -->
    <aliVerify ref="aliVerify" @getAliVerifyObj="getAliVerifyObj"></aliVerify>
    <!-- 问题详情 -->
    <van-popup
      class="popup"
      position="bottom"
      v-model="show"
      :close-on-click-overlay="false"
      @click-overlay="show = false"
    >
      <div class="popup-content">
        <div class="title-bg"></div>
        <div class="popup-handle">
          <div class="qa-title">
            <i class="qa-icon"></i>
            {{ qaDetail.title }}
          </div>
          <div class="qa-content" v-html="qaDetail.content"></div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { parseParamId } from 'utils/index.js'
import { postQaAnswerJson } from 'api/qa/questions.js'
import MobileHeader from 'component/qa/MobileHeader'
import { Field, Popup, Dialog } from 'vant'
import aliVerify from 'component/qa/questions/aliVerify.vue' // 智能验证
import { commonGetToken } from 'utils/tool.js'

export default {
  props: {
    qaDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isShowToast: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MobileHeader,
    [Field.name]: Field,
    aliVerify,
    [Popup.name]: Popup
  },
  data() {
    return {
      showDialog: false,
      showPlaceholder: true,
      formData: {
        content: '', // 提问内容
        question_id: '',
        token: '', //
        nc_sessionid: '',
        nc_token: '',
        nc_sig: '',
        nc_scene: '',
        nc_appkey: ''
      },
      aliVerifyObj: {},
      show: false
    }
  },
  computed: {
    questionId() {
      const id = this.$route.params.id
      return parseParamId(id)
    }
  },
  watch: {
    showDialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.calcTextAreaHeght()
        })
        if (this.$platform.isYixinliApp) {
          this.$bridge.isPullRefreshEnable({ enable: 0 })
        }
        // 隐藏页面主体内容，避免编辑滚动时引发页面滚动
        this.$emit('toggleBodyVisiable', true)
      } else {
        if (this.$platform.isYixinliApp) {
          this.$bridge.isPullRefreshEnable({ enable: 1 })
        }
        this.$emit('toggleBodyVisiable', false)
      }
    }
  },
  mounted() {
    let content = localStorage.getItem(`qa-content-${this.questionId}`)
    this.$set(this.formData, 'content', content)
  },
  methods: {
    calcTextAreaHeght() {
      const header = this.$refs.mobileHeader.$el
      if (header) {
        this.autoSize = {
          maxHeight: window.innerHeight - header.offsetHeight * 1.5
        }
      }
    },
    goQaIndex() {
      if (!this.formData.content) {
        this.showDialog = false
        return
      }
      Dialog.confirm({
        title: `是否保存草稿`,
        message: `退出将不保留本次回答草稿`,
        className: 'qa-question-detail-vant-dialog',
        confirmButtonText: '保存草稿',
        cancelButtonText: '不保存退出'
      })
        .then(() => {
          this.showDialog = false
        })
        .catch(() => {
          this.$set(this.formData, 'content', '')
          localStorage.setItem(`qa-content-${this.questionId}`, '')
          this.showDialog = false
        })
    },
    rightFun() {
      if (this.formData.content.trim() === '') {
        this.$toast({ text: '请详细描述你的问题不能为空', zIndexTop: 9999 })
        return
      }
      this.$refs.aliVerify.show = true
      this.$refs.aliVerify.getQaSubmitVerify()
    },
    // 获取智能验证参数
    getAliVerifyObj(data) {
      this.aliVerifyObj = data
      this._postQaQuestion()
      this.$refs.aliVerify.show = false
    },
    _postQaQuestion() {
      let { sessionId, token, sig, scene, appkey } = this.aliVerifyObj
      let params = {
        ...this.formData,
        question_id: this.questionId,
        token: this.user_info?.token,
        nc_sessionid: sessionId,
        nc_token: token,
        nc_sig: sig,
        nc_scene: scene,
        nc_appkey: appkey
      }
      return commonGetToken(this)
        .then(token => {
          params.token = token
          return postQaAnswerJson(params)
        })
        .then(({ code, message, data }) => {
          if (code === 0) {
            if (!this.isShowToast) {
              this.$toast({
                text: message || '提交成功',
                zIndexTop: true
              })
            }
            localStorage.setItem(`qa-content-${this.questionId}`, '')
            this.$emit('update', data.id)
          } else {
            this.$toast({
              text:
                message ||
                `提交失败(${code})，请重新编辑提交，如还有问题请添加答疑馆-喵酱（微信号：dolphin_xinli001）~喵~`,
              zIndexTop: true
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$toast({
            text: '网络异常！',
            zIndexTop: true
          })
        })
        .finally(() => {
          this.showDialog = false
        })
    },
    changeContent(val) {
      localStorage.setItem(`qa-content-${this.questionId}`, val)
    }
  }
}
</script>
<style lang="scss">
.qa-question-detail-vant-dialog {
  width: 560px !important;
  .van-dialog__content--isolated {
    min-height: auto !important;
  }
  .van-dialog__header {
    font-size: 32px !important;
    font-weight: 600 !important;
    color: #21252d !important;
  }
  .van-dialog__message {
    font-size: 28px !important;
    font-weight: 400 !important;
    color: #6c798c !important;
    text-align: center !important;
  }
  .van-dialog__cancel {
    font-size: 32px !important;
    font-weight: 600 !important;
    color: #9da3ac !important;
  }
  .van-dialog__confirm {
    font-size: 32px !important;
    font-weight: 600 !important;
    color: #6982fa !important;
  }
}
</style>
<style lang="scss" scoped>
.answer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background: #f9f9f9;
  .nav-title {
    background: #fff;
    font-size: 36px !important;
    font-weight: 600;
    color: #6982fa !important;
  }
  .nav-right-text {
    width: 44px;
    height: 44px;
    background: url('../../../images/qa/questions/icon-nosend.png') no-repeat
      center/100% 100%;
    &.active {
      background: url('../../../images/qa/questions/icon-send.png') no-repeat
        center/100% 100%;
    }
  }
  .post-question-content {
    position: relative;
    .question {
      .question-field {
        padding: 0;
        background: transparent;
        ::v-deep .van-field__body {
          width: 100%;
          background: transparent;
        }
        ::v-deep .van-field__control {
          width: 100%;
          background: transparent;
        }
      }
      .question-title {
        font-size: 38px;
        font-weight: 600;
        color: #21252d;
        line-height: 46px;
      }
      .question-content {
        font-size: 32px;
        font-weight: 400;
        color: #434c5c;
        line-height: 48px;
        ::v-deep .van-field__control {
          height: 320px;
          padding: 30px 32px 10px 32px;
          color: #434c5c !important;
        }

        ::v-deep .van-field__word-limit {
          color: #bcc2cf !important;
        }
        &.active {
          ::v-deep .van-field__word-limit {
            color: #21252d !important;
          }
        }
      }
      .link {
        margin: 12px auto;
        width: 686px;
        height: 2px;
        background: #eaeaea;
      }
    }
  }

  .placeholder {
    position: absolute;
    top: 28px;
    left: 32px;
    padding: 10px 0;
    z-index: -1;
    font-weight: 400;
    .placeholder-title {
      font-size: 38px;
      color: #9da3ac;
      line-height: 53px;
    }
    .textear-div {
      margin-top: 20px;
      font-size: 32px;
      color: #bcc2cf;
      line-height: 48px;
    }
  }

  .tip {
    margin: 48px 0 0 32px;
    .tip-box {
      padding: 20px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      font-weight: 400;
      color: #21252d;
      line-height: 40px;
      background: #f3f4f5;
      border-radius: 45px;
    }
    .add-tip {
      .tips {
        margin: 0 10px;
      }
      .icon-add {
        width: 38px;
        height: 38px;
      }
      .icon-right {
        width: 17px;
        height: 16px;
      }
    }
  }

  .van-popup {
    background-color: transparent;
  }
  .popup-content {
    // position: relative;
    width: 750px;
    padding: 64px 32px;
    min-height: 904px;
    max-height: 80vh;
    overflow-y: scroll;
    background: #f3f4f5;
    border-radius: 30px 30px 0px 0px;
    font-size: 36px;
    line-height: 36px;
    box-sizing: border-box;
    .title-bg {
      position: absolute;
      top: 0;
      left: 0;
      height: 64px;
      width: 100%;
      border-radius: 30px 30px 0px 0px;
      background: #f3f4f5;
    }
    .popup-handle {
      .qa-title {
        font-size: 36px;
        font-weight: 600;
        color: #21252d;
        line-height: 50px;
        .qa-icon {
          float: left;
          width: 38px;
          height: 38px;
          margin-top: 6px;
          margin-right: 12px;
          background: url('../../../images/qa/questions/icon-wenti.png')
            no-repeat center/100% 100%;
        }
      }
      .qa-content {
        margin-top: 30px;
        font-size: 30px;
        font-weight: 400;
        color: #6c798c;
        line-height: 50px;
      }
    }
  }
}
</style>
